import { ReactElement, useState } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import { keys, isEmpty } from 'lodash'

import { Tag } from 'components/v2/Tag'
import { getQueryString } from 'utils/route'
import { Input } from 'components/Input'
import { Select } from 'components/v2/Select'
import { CONCILIATION_STATUS } from 'features/Inventories/components/ConciliationStatus/constants'
import { conciliationStatusMessages } from 'features/Inventories/components/ConciliationStatus/messages'
import { ItemAutocomplete, getItemLabel } from 'features/Snacks/components/ItemAutocomplete'
import { sortByTranslation } from 'utils/intl'
import {
  FilterHeader,
  FilterToggle,
  FilterWrapper,
  FiltersContainer,
  FiltersSubmit,
  FiltersWrapper,
  TagsWrapper
} from 'components/Filters'

const ORDER_CONCILIATION_STATUS_LIST = [CONCILIATION_STATUS.CONFLICTING, CONCILIATION_STATUS.COMPLETED]

const messages = defineMessages({
  idPlaceholder: {
    id: 'spanish.inventoryInbounds.filters.idPlaceholder',
    defaultMessage: 'Id'
  },
  conciliationStatus: {
    id: 'spanish.inventoryInbounds.filters.selectConciliationStatus',
    defaultMessage: 'Seleccionar estado de conciliación'
  },
  itemIdPlaceholder: {
    id: 'spanish.inventoryInbounds.filters.itemIdPlaceholder',
    defaultMessage: 'Producto'
  }
})

export const InboundsFilters = ({ filters, inventoryId, companyId }: TSFixMe): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const [isShowingFilters, showFilters] = useState(false)

  const toggleFilters = (): TSFixMe => {
    showFilters(!isShowingFilters)
  }

  const sortConciliationStatusByTranslation = (): TSFixMe => {
    return ORDER_CONCILIATION_STATUS_LIST.sort(
      (a, b): TSFixMe => sortByTranslation(a, b, intl, conciliationStatusMessages)
    )
  }

  const filterInboundsInventory = (values: TSFixMe): TSFixMe => {
    const query = {
      id: values.id,
      conciliationStatus: values.conciliationStatus,
      itemId: values.item && values.item.id
    }

    navigate(`/inventories/${inventoryId}/inbounds?${getQueryString(query)}`)
  }

  const initialValues = {
    id: filters.id || '',
    conciliationStatus: filters.conciliationStatus || '',
    item: filters.item || { id: '' }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={filterInboundsInventory} enableReinitialize>
      {(props): ReactElement => {
        const { handleChange, handleSubmit, setFieldValue, values } = props

        const handleSelectChange = (event: TSFixMe): TSFixMe => {
          const {
            target: { id, value }
          } = event

          handleChange(event)

          filterInboundsInventory({
            ...values,
            [id]: value
          })
        }

        const handleFilterDelete = (id: TSFixMe): TSFixMe => {
          setFieldValue(id, '')
          filterInboundsInventory({
            ...values,
            [id]: ''
          })
        }

        return (
          <form onSubmit={handleSubmit}>
            <div>
              <FilterHeader>
                <FilterWrapper>
                  <FilterToggle onClick={toggleFilters} />
                  <TagsWrapper>
                    {keys(filters).map((filterKey): TSFixMe => {
                      let label, value
                      const filterValue = filters[filterKey]
                      const hasValue = (filterValue && filterValue.getTime) || !isEmpty(filterValue)

                      if (!hasValue) return null

                      switch (filterKey) {
                        case 'id':
                          label = <FormattedMessage id="spanish.dictionary.id" defaultMessage="Id" />
                          value = filterValue
                          break
                        case 'conciliationStatus':
                          label = (
                            <FormattedMessage
                              id="spanish.dictionary.conciliationStatus"
                              defaultMessage="Estado de conciliación"
                            />
                          )
                          value =
                            conciliationStatusMessages[filterValue] &&
                            intl.formatMessage(conciliationStatusMessages[filterValue])
                          break
                        case 'item':
                          label = <FormattedMessage id="spanish.dictionary.name" defaultMessage="Producto" />
                          value = getItemLabel(filterValue, intl)
                          break
                      }

                      return (
                        <Tag key={filterKey} onDelete={handleFilterDelete.bind(this, filterKey)}>
                          {label}: {value}
                        </Tag>
                      )
                    })}
                  </TagsWrapper>
                </FilterWrapper>
              </FilterHeader>
              <FiltersWrapper isShowingFilters={isShowingFilters}>
                <FiltersContainer>
                  <Input
                    id="id"
                    value={values.id}
                    onChange={handleChange}
                    placeholder={intl.formatMessage(messages.idPlaceholder)}
                    label={<FormattedMessage id="spanish.dictionary.id" defaultMessage="Id" />}
                  />
                  <Select
                    id="conciliationStatus"
                    value={values.conciliationStatus}
                    onChange={handleSelectChange}
                    label={
                      <FormattedMessage
                        id="spanish.dictionary.conciliationStatus"
                        defaultMessage="Estado de conciliación"
                      />
                    }
                  >
                    <option value="">{intl.formatMessage(messages.conciliationStatus)}</option>
                    {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
                    {sortConciliationStatusByTranslation(values.conciliationStatus).map(
                      (conciliationStatus: TSFixMe): TSFixMe => {
                        return (
                          <option value={conciliationStatus} key={conciliationStatus}>
                            {intl.formatMessage(conciliationStatusMessages[conciliationStatus])}
                          </option>
                        )
                      }
                    )}
                  </Select>
                  <ItemAutocomplete
                    placeholder={intl.formatMessage(messages.itemIdPlaceholder)}
                    value={getItemLabel(values.item, intl)}
                    label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Producto" />}
                    onChange={(item: TSFixMe): TSFixMe => {
                      setFieldValue('item', item)

                      filterInboundsInventory({
                        ...values,
                        item
                      })
                    }}
                    companyId={companyId}
                  />
                </FiltersContainer>
              </FiltersWrapper>
            </div>
            <FiltersSubmit />
          </form>
        )
      }}
    </Formik>
  )
}
